import SearchPage from '../../components/page/search/SearchPage';
export default SearchPage;
